module.exports = __webpack_public_path__ + "static/media/group-7-copy.3ea0b26f.svg";